import { jsx as _jsx } from "react/jsx-runtime";
import { Accordion } from '@chakra-ui/react';
export { NumberedAccordionButton } from './NumberedAccordionButton';
export { NumberedAccordionItem } from './NumberedAccordionItem';
export { NumberedAccordionNumber } from './NumberedAccordionNumber';
export { NumberedAccordionPanel } from './NumberedAccordionPanel';
export { NumberedAccordionTitle } from './NumberedAccordionTitle';
export const NumberedAccordion = (props) => {
    return _jsx(Accordion, { allowToggle: true, ...props });
};
